import { useEffect, useRef, useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { FadeUp } from "../components/Reveal";

export default function PortalMessages() {
  const [messages, setMessages] = useState([]);
  const [body, setBody] = useState("");
  const bottomRef = useRef(null);

  const load = () => api.get("/messages/mine").then((r) => setMessages(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 6000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages.length]);

  const send = async (e) => {
    e.preventDefault();
    if (!body.trim()) return;
    try {
      await api.post("/messages", { body: body.trim() });
      setBody("");
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div className="max-w-3xl" data-testid="portal-messages">
      <FadeUp>
        <h1 className="font-serif text-3xl sm:text-4xl text-obsidian">Message <span className="italic text-purple-700">Empress</span></h1>
        <p className="text-sm text-slate-500 mt-2">A direct line to the studio — references, revision notes, questions.</p>
      </FadeUp>

      <FadeUp delay={0.1} className="mt-8 bg-white rounded-3xl border border-purple-100 flex flex-col h-[60vh]">
        <div className="flex-1 overflow-y-auto slim-scroll p-6 space-y-4">
          {messages.map((m) => (
            <div key={m.message_id} className={`flex ${m.sender === "client" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[75%] rounded-2xl px-5 py-3.5 text-sm leading-relaxed ${
                m.sender === "client"
                  ? "bg-purple-700 text-white rounded-br-sm"
                  : "bg-lilac-mist text-slate-700 rounded-bl-sm"
              }`} data-testid={`message-${m.message_id}`}>
                {m.sender === "admin" && <p className="text-[10px] font-mono uppercase tracking-widest text-gold mb-1">Empress</p>}
                {m.body}
              </div>
            </div>
          ))}
          {messages.length === 0 && <p className="text-sm text-slate-400 italic text-center pt-16">Say hi — Empress replies personally.</p>}
          <div ref={bottomRef} />
        </div>
        <form onSubmit={send} className="p-4 border-t border-purple-100 flex gap-3">
          <input value={body} onChange={(e) => setBody(e.target.value)} placeholder="Write to Empress…" data-testid="message-input"
            className="flex-1 rounded-full border border-purple-100 px-5 py-3 text-sm focus:outline-none focus:border-purple-400" />
          <button type="submit" data-testid="message-send-btn"
            className="w-12 h-12 rounded-full bg-obsidian text-white flex items-center justify-center hover:text-gold transition-colors shrink-0" aria-label="Send message">
            <Send size={17} />
          </button>
        </form>
      </FadeUp>
    </div>
  );
}
